<div>
     <span *ngIf="hideButton === false" class="pr-2">
          <button
               type="button"
               [class]="buttonClass"
               (click)="buttonClick(params)"
               [name]="buttonName"
               [id]="buttonName"
               [disabled]="disableButton"
          >
               {{ buttonText }}
               <i *ngIf="buttonIcon !== ''" [class]="buttonIcon"></i>
          </button>
     </span>
     <label class="hide-button-text"
     > {{hideButtonText}} </label>

     <span *ngIf="hideProbationButton === false">
          <button
               type="button"
               [class]="probationButtonClass"
               (click)="probationButtonClick(params)"
               [name]="probationButtonName"
               [id]="probationButtonName"
          >
               {{ probationButtonText }}
               <i *ngIf="probationButtonIcon !== ''" [class]="probationButtonIcon"></i>
          </button>
     </span>

     <span *ngIf="hideReorderButton === false" class="pr-2">
          <button
               type="button"
               [class]="reorderButtonClass"
               (click)="reorderButtonClick(params)"
               [name]="reorderButtonName"
               [id]="reorderButtonName"
               [ngbPopover]="reorderButtonPopoverText"
               triggers="mouseenter:mouseleave"
               placement="top"
               container="body"
               [disabled]="reorderButtonDisabled"
          >
               <i *ngIf="reorderButtonIcon !== ''" [class]="reorderButtonIcon"></i>{{ reorderButtonText }}
          </button>
     </span>
</div>

